import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { Separator } from 'telia-front-react';
import AnalyticsService from '../../../services/AnalyticsService';
import InvoiceSettingsModalStore from '../../../stores/InvoiceSettingsModalStore';
import InvoiceSettingsStore from '../../../stores/InvoiceSettingsStore';
import { ITranslateStore } from '../../../stores/TranslateStore';
import NoticeWithButton from '../../common/NoticeWithButton';

interface IPaperInvoiceNoticeProps {
  invoiceSettingsStore?: InvoiceSettingsStore;
  invoiceSettingsModalStore?: InvoiceSettingsModalStore;
  translateStore?: ITranslateStore;
  analyticsService?: AnalyticsService;
}

@inject('invoiceSettingsStore', 'invoiceSettingsModalStore', 'translateStore', 'analyticsService')
@observer
export default class PaperInvoiceNotice extends React.Component<IPaperInvoiceNoticeProps> {
  public componentDidMount(): void {
    this.props.invoiceSettingsStore.tryLoadInvoiceSettings();
  }

  public render(): JSX.Element {
    const { customerInvoicesSettings } = this.props.invoiceSettingsStore;

    if (!customerInvoicesSettings.isFinished) {
      return null;
    }

    const { hasPaperInvoice } = this.props.invoiceSettingsStore;
    const { translate } = this.props.translateStore;

    if (hasPaperInvoice) {
      return (
        <>
          <NoticeWithButton
            gaEvent="CTA - get electronic invoice"
            noticeText={translate('invoices.notices.cta.get-electronic-invoice')}
            buttonProps={{
              text: translate('invoices.notices.cta.get-electronic-invoice.button'),
              onClick: () => {
                const firstInvoiceRefNum: string = this.props.invoiceSettingsStore.customerInvoicesSettings.payload.invoiceSettings[0].refNumber;
                this.props.invoiceSettingsModalStore.openModal(firstInvoiceRefNum);
                this.props.analyticsService.ctaGetElectronicInvoice();
              }
            }}
          />
          <Separator color="invisible" spacing="xxsmall" />
        </>
      );
    }

    return null;
  }
}
